/* Shared theme guidance; hosted Shopify checkout is outside this control. */
(function () {
  'use strict';
  const messages = {
    en: ['$30 minimum for plant orders', 'Add ', ' more in plants', ' to check out.', 'Seed-only orders have no minimum.', 'Browse plants'],
    fr: ['Minimum de 30 $ pour les commandes de plants', 'Ajoutez encore ', ' de plants', ' pour passer à la caisse.', 'Aucun minimum pour les commandes contenant uniquement des semences.', 'Voir les plants'],
    es: ['Pedido mínimo de plantas: 30 $', 'Añade ', ' más en plantas', ' para finalizar la compra.', 'Los pedidos que solo contienen semillas no tienen importe mínimo.', 'Ver plantas']
  };
  window.OsnPlantMinimum = {
    render(container, state, currency) {
      container.replaceChildren();
      container.hidden = !state?.blocked;
      if (!state?.blocked) return;
      const locale = (document.documentElement.lang || 'en').split('-')[0];
      const copy = messages[locale] || messages.en;
      const amount = new Intl.NumberFormat(locale === 'fr' ? 'fr-CA' : locale === 'es' ? 'es-CA' : 'en-CA', {style:'currency', currency:currency || state.currency || 'CAD'}).format(state.remaining / 100);
      const heading = document.createElement('p');
      heading.className = 'osn-plant-minimum__title';
      heading.textContent = copy[0];
      const text = document.createElement('p');
      const remaining = document.createElement('strong');
      remaining.textContent = amount + copy[2];
      text.append(copy[1], remaining, copy[3]);
      const scope = document.createElement('p');
      scope.className = 'osn-plant-minimum__scope';
      scope.textContent = copy[4];
      const link = document.createElement('a');
      link.href = (window.Shopify?.routes?.root || '/') + 'collections/fall-potted-plant-sale';
      link.textContent = copy[5];
      container.append(heading, text, scope, link);
    }
  };
  // Native cart forms: catch Enter submission as well as checkout button clicks.
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (form.id === 'cart-notification-form') {
      // The legacy added-to-cart popup is updated separately from cart sections.
      // Read current policy before its direct checkout submission.
      event.preventDefault();
      if (form.dataset.minimumChecking) return;
      form.dataset.minimumChecking = 'true';
      const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
      fetch(cartUrl + '?sections=main-cart-items', {credentials:'same-origin',cache:'no-store'})
        .then(response => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
        .then(sections => {
          const doc = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
          const state = JSON.parse(doc.querySelector('[data-osn-plant-minimum-state]').textContent);
          if (state.blocked) { location.assign(cartUrl); return; }
          const checkout = document.createElement('input'); checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'checkout';
          form.append(checkout); form.submit();
        })
        .catch(() => location.assign(cartUrl))
        .finally(() => { delete form.dataset.minimumChecking; });
      return;
    }
    if (!['cart','CartDrawer-Form'].includes(form.id)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    const scope = form.id === 'cart' ? document : form.closest('cart-drawer');
    const notice = scope?.querySelector('[data-osn-plant-minimum][data-blocked="true"]');
    if (notice) { event.preventDefault(); notice.querySelector('a')?.focus(); }
  }, true);
})();
